<template>
    <component
        :is="tag" 
        :href="href !== '' ? href : false" 
        :class="[...modifiersMap, { 'ButtonLink': true }]"
        :target="target !== '' ? target : false" 
        :download="download"
    >
      {{ text }}
      <slot></slot>
    </component>
</template>

<script>
import { ModifiersMap } from '@studapart/core'

export default {
    name: "ButtonLink",
    mixins: [ ModifiersMap ],
    props: {
        text: { type: String, default: "" },
        modifiers: { type: Array, default: () => [] },
        tag: { type: String, default: "a" },
        href: { type: String, default: "" },
        target: { type: String, default: "" },
        download: { type: Boolean, default: false }
    }
}
</script>